var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1829 7.04183C16.3079 3.19183 12.9496 1.4585 9.99959 1.4585C9.99959 1.4585 9.99959 1.4585 9.99126 1.4585C7.04959 1.4585 3.68292 3.1835 2.80792 7.0335C1.83292 11.3335 4.46626 14.9752 6.84959 17.2668C7.73292 18.1168 8.86626 18.5418 9.99959 18.5418C11.1329 18.5418 12.2663 18.1168 13.1413 17.2668C15.5246 14.9752 18.1579 11.3418 17.1829 7.04183Z",
    fill: "#B90022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2168C11.4497 11.2168 12.625 10.0415 12.625 8.5918C12.625 7.14205 11.4497 5.9668 10 5.9668C8.55025 5.9668 7.375 7.14205 7.375 8.5918C7.375 10.0415 8.55025 11.2168 10 11.2168Z",
    fill: "#B90022"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f868ff8aafd1360acb25f4ba81ea3ce9.svg";
export { ForwardRef as ReactComponent };